import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from '../utils/axios';
import { toast } from 'react-hot-toast';

const InvitationReject = () => {
  const { token } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const rejectInvitation = async () => {
      try {
        const response = await axios.get(`/invite/reject/${token}`);

        if (response.data.success) {
          toast.success('Invitation rejected successfully');
          // Redirect to home or login
          navigate('/');
        } else {
          setError(response.data.message || 'Failed to reject invitation');
        }
      } catch (err) {
        setError(err.response?.data?.message || 'An unexpected error occurred');
      } finally {
        setLoading(false);
      }
    };

    rejectInvitation();
  }, [token, navigate]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <div className="animate-spin rounded-full h-16 w-16 border-t-2 border-red-500 mx-auto mb-4"></div>
          <p className="text-gray-600">Rejecting invitation...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="bg-white shadow-md rounded-lg p-8 max-w-md w-full">
          <h2 className="text-2xl font-bold text-red-600 mb-4">Invitation Error</h2>
          <p className="text-gray-700 mb-6">{error}</p>
          <button
            onClick={() => navigate('/')}
            className="w-full bg-indigo-600 text-white py-2 px-4 rounded-md hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500"
          >
            Go to Home
          </button>
        </div>
      </div>
    );
  }

  return null;
};

export default InvitationReject;
